/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
}

export function base64ToBlob(base64) {
  let bytes = window.atob(base64.split(",")[1]);

  let array = [];
  for (let i = 0; i < bytes.length; i++) {
    array.push(bytes.charCodeAt(i));
  }
  let blob = new Blob([new Uint8Array(array)], {
    type: "image/png"
  });
  return blob;
}

export function isNull(e) {
  let bool = false;
  if (typeof e === "object") {
    if (!e) {
      bool = true;
    }
  }
  return bool;
}

export const RegRule = {
  /*
   *字符串验证规则
   */

  phone: /^1\d{10}$/, //手机号码
  tel: /(^(0\d{2}-?)?\d{8}$)|(^(0\d{3}-?)?\d{7}$)/, //固定电话
  telOrPhone: /(^(?:\+?86)?1\d{10}$)|((^(0\d{2}-?)?\d{8}$)|(^(0\d{3}-?)?\d{7}$))/ //手机号码或者固话号码
};

export class Validation {
  /*
   *验证字符串
   */
  static phone(str) {
    //手机号码
    return RegRule.phone.test(str);
  }
  static tel(str) {
    //固定电话
    return RegRule.tel.test(str);
  }
  static telOrPhone(str) {
    //固话或手机
    return RegRule.telOrPhone.test(str);
  }
}

let template = (rule, value, callback, hint1, hint2, ruleName) => {
  /*
   *el-form表单验证方法公用模板
   *hint1: 提示信息1，值为空时
   *hint2: 提示信息2，值格式错误时
   */
  if (rule.required) {
    if (value == "") {
      callback(new Error(hint1));
    } else if (!RegRule[ruleName].test(value)) {
      callback(new Error(hint2));
    } else {
      callback();
    }
  } else if (value != "") {
    if (!RegRule[ruleName].test(value)) {
      callback(new Error(hint2));
    } else {
      callback();
    }
  } else {
    callback();
  }
};

export class ElValidation {
  /*
   *el-form表单的验证方法
   *@rule: el-form的验证规则对象
   *@value: 需要验证的值，一般为input等的value
   */
  static phone(rule, value, callback) {
    //验证手机号
    template(
      rule,
      value,
      callback,
      "请输入手机号码",
      "请输入正确的手机号码",
      "phone"
    );
  }
  static tel(rule, value, callback) {
    //验证固话
    template(
      rule,
      value,
      callback,
      "请输入固话号码",
      "请输入正确的固话号码",
      "tel"
    );
  }
  static telOrPhone(rule, value, callback) {
    //验证固话
    template(
      rule,
      value,
      callback,
      "请输入固话号码或手机号码",
      "请输入正确的固话号码或手机号码",
      "telOrPhone"
    );
  }
}
